export type ServiceRegion = {
  id: string;
  name: string;
  centre_lat: number;
  centre_lng: number;
  radius_km: number;
  pincodes: string[];
  is_active: boolean;
  notes: string | null;
  /** Vendors attributed to this region at the last recompute. */
  vendor_count: number;
  created_at: string;
  updated_at: string;
};

/** Every write returns the new split, so the console can say what just changed. */
export type RecomputeTally = {
  serviceable: number;
  out_of_area: number;
  location_unknown: number;
};

export type RegionMutationResult = { region: ServiceRegion; tally: RecomputeTally };

/**
 * The list, plus the state of the platform as a whole.
 *
 * `gating_enabled` is keyed on a region EXISTING, not on one being live. No regions means the
 * platform is open everywhere; regions that are all paused means it is CLOSED everywhere. Both
 * render as "nothing live", which is exactly why the screen has to be told which it is.
 */
export type ServiceRegionList = {
  items: ServiceRegion[];
  tally: RecomputeTally;
  gating_enabled: boolean;
};

export type RegionInput = {
  name: string;
  centre_lat: number;
  centre_lng: number;
  radius_km: number;
  pincodes?: string[];
  is_active?: boolean;
  notes?: string;
};

export type CoveragePreview = {
  vendors_covered: number;
  vendors_total: number;
  sample: { id: string; business_name: string | null; city: string | null }[];
};

export type ServiceabilityCheck = {
  status: 'SERVICEABLE' | 'OUT_OF_AREA' | 'LOCATION_UNKNOWN';
  region: { id: string; name: string } | null;
};

/**
 * Somewhere to start from when drawing a region, so an admin isn't typing raw
 * coordinates from memory. Not a business list — purely a convenience.
 */
export const CITY_PRESETS: { label: string; lat: number; lng: number }[] = [
  { label: 'Bengaluru', lat: 12.9716, lng: 77.5946 },
  { label: 'Delhi', lat: 28.6139, lng: 77.209 },
  { label: 'Gurugram', lat: 28.4595, lng: 77.0266 },
  { label: 'Noida', lat: 28.5355, lng: 77.391 },
  { label: 'Mumbai', lat: 19.076, lng: 72.8777 },
  { label: 'Hyderabad', lat: 17.385, lng: 78.4867 },
  { label: 'Pune', lat: 18.5204, lng: 73.8567 },
  { label: 'Lucknow', lat: 26.8467, lng: 80.9462 },
];
